// Mock data para Plataforma AJ BIM

export const courses = [
  {
    id: 1,
    title: 'Revit Expert',
    description: 'Domine o Revit do básico ao avançado e torne-se um especialista em modelagem BIM para arquitetura, estrutura e instalações.',
    duration: '120 horas',
    level: 'Intermediário a Avançado',
    modules: 12,
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80',
    prices: {
      ead_recorded: 1497.00,
      ead_live: 2497.00,
      presential: 3497.00
    },
    features: [
      'Modelagem arquitetônica completa',
      'Documentação e detalhamento',
      'Famílias paramétricas',
      'Compatibilização de projetos',
      'Renderização e apresentação',
      'Certificado de conclusão'
    ]
  },
  {
    id: 2,
    title: 'BIM Mindset e Fundamentos',
    description: 'Entenda a filosofia BIM, suas aplicações práticas e como implementar uma cultura BIM em sua organização.',
    duration: '40 horas',
    level: 'Iniciante',
    modules: 6,
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    prices: {
      ead_recorded: 697.00,
      ead_live: 1197.00,
      presential: 1697.00
    },
    features: [
      'Conceitos fundamentais BIM',
      'Dimensões do BIM (3D a 7D)',
      'Gestão de informações',
      'Workflows colaborativos',
      'Estudos de caso reais',
      'Certificado de conclusão'
    ]
  }
];

export const consultingServices = [
  {
    id: 1,
    title: 'Implementação BIM',
    description: 'Estratégia completa de implementação BIM adaptada à realidade da sua empresa',
    icon: 'Workflow'
  },
  {
    id: 2,
    title: 'Diagnóstico BIM',
    description: 'Análise detalhada do nível de maturidade BIM da sua organização',
    icon: 'FileSearch'
  },
  {
    id: 3,
    title: 'Planejamento Estratégico',
    description: 'Roadmap personalizado para adoção BIM em todas as fases',
    icon: 'Target'
  },
  {
    id: 4,
    title: 'Capacitação Corporativa',
    description: 'Treinamentos específicos para as necessidades da sua equipe',
    icon: 'Users'
  }
];

export const methodology = [
  {
    step: 1,
    title: 'Levantamento de Informações',
    description: 'Análise completa dos processos atuais, ferramentas utilizadas e objetivos da organização.',
    duration: '2-4 semanas'
  },
  {
    step: 2,
    title: 'Diagnóstico Detalhado',
    description: 'Avaliação do nível de maturidade BIM e identificação de gaps e oportunidades de melhoria.',
    duration: '1-2 semanas'
  },
  {
    step: 3,
    title: 'Planejamento Estratégico',
    description: 'Desenvolvimento do roadmap de implementação BIM personalizado com cronograma e marcos.',
    duration: '2-3 semanas'
  },
  {
    step: 4,
    title: 'Implementação',
    description: 'Execução do plano com capacitações, criação de documentação e acompanhamento contínuo.',
    duration: 'Variável'
  }
];

export const subProducts = [
  {
    title: 'BIM Mandate',
    description: 'Documento que estabelece os requisitos e diretrizes BIM para projetos',
    icon: 'FileText'
  },
  {
    title: 'Plano de Execução BIM (BEP)',
    description: 'Planejamento detalhado de como o BIM será aplicado no projeto',
    icon: 'ClipboardList'
  },
  {
    title: 'Templates BIM',
    description: 'Modelos padronizados para iniciar projetos com configurações otimizadas',
    icon: 'Layout'
  },
  {
    title: 'Bibliotecas BIM',
    description: 'Famílias e componentes paramétricos customizados',
    icon: 'Library'
  },
  {
    title: 'Protocolos de Modelagem',
    description: 'Diretrizes para garantir qualidade e consistência nos modelos',
    icon: 'Settings'
  },
  {
    title: 'Workflows Colaborativos',
    description: 'Processos estruturados para trabalho em equipe',
    icon: 'Network'
  }
];

export const otherServices = [
  {
    title: 'Coordenação BIM',
    description: 'Gestão e compatibilização de projetos multidisciplinares',
    icon: 'GitMerge'
  },
  {
    title: 'Modelagem BIM',
    description: 'Desenvolvimento de modelos BIM para arquitetura, estrutura e instalações',
    icon: 'Box'
  },
  {
    title: 'Gêmeos Digitais',
    description: 'Criação de réplicas digitais para monitoramento e gestão de ativos',
    icon: 'Layers'
  },
  {
    title: 'Scanners e Drones',
    description: 'Levantamentos de nuvem de pontos, modelagem 3D de edificações e terrenos existentes',
    icon: 'Scan'
  },
  {
    title: 'City Information Modeling',
    description: 'Modelagem de informações urbanas para planejamento de cidades',
    icon: 'Building2'
  },
  {
    title: 'Levantamento de Cidades',
    description: 'Mapeamento e digitalização de ambientes urbanos',
    icon: 'Map'
  }
];

export const youtubeVideos = [
  {
    id: 'VIDEO_ID_1',
    title: 'Revit - Uma Casa Completa',
    description: 'Apresentação completa do curso Revit Expert',
    thumbnail: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&q=80'
  },
  {
    id: 'VIDEO_ID_2',
    title: 'O que é BIM?',
    description: 'Introdução aos conceitos fundamentais',
    thumbnail: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80'
  },
  {
    id: 'VIDEO_ID_3',
    title: 'Implementação BIM na Prática',
    description: 'Casos reais de sucesso',
    thumbnail: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80'
  }
];

export const testimonials = [
  {
    name: 'Carlos Silva',
    role: 'Arquiteto',
    company: 'Silva Arquitetura',
    content: 'O curso Revit Expert transformou minha forma de trabalhar. Consegui aumentar minha produtividade em 300%!',
    avatar: 'https://i.pravatar.cc/150?img=12'
  },
  {
    name: 'Marina Santos',
    role: 'Coordenadora BIM',
    company: 'Construtora XYZ',
    content: 'A consultoria de implementação BIM foi essencial para estruturar nossos processos. Resultados incríveis!',
    avatar: 'https://i.pravatar.cc/150?img=45'
  },
  {
    name: 'Roberto Oliveira',
    role: 'Engenheiro Civil',
    company: 'Projetos ABC',
    content: 'Conteúdo de altíssima qualidade. A didática do Alex é excepcional!',
    avatar: 'https://i.pravatar.cc/150?img=33'
  }
];